import { css } from "@compiled/react";

import { token } from "@atlaskit/tokens";

export type InfoBoxProps = {
    readonly imageUrl?: string;
    readonly imageHeight?: number;
    readonly imageWidth?: number;
    readonly containerWidth?: string;
    readonly title: string;
    readonly paragraph: string;
};

const infoBoxContainerStyles = css({
    display: "flex",
    minHeight: "158",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    flexShrink: "0"
});

const imageStyles = css({
    maxWidth: "100%",
    marginBlockEnd: "10px"
});

const titleStyles = css({
    margin: 0,
    padding: `${token("space.100")}`,
    display: "flex",
    flexDirection: "row",
    alignItems: "start"
});

const paragraphStyles = css({
    minHeight: "112px",
    margin: 0,
    marginBlockEnd: "auto",
    padding: `${token("space.100")}`
});

export const InfoBox = ({
    imageUrl,
    imageHeight,
    imageWidth,
    containerWidth,
    title,
    paragraph
}: InfoBoxProps) => {
    return (
        <div
            css={infoBoxContainerStyles}
            style={{ width: containerWidth ?? 290 }}
        >
            {imageUrl && (
                // eslint-disable-next-line no-restricted-syntax
                <img
                    css={imageStyles}
                    src={imageUrl}
                    alt={title}
                    height={imageHeight ? imageHeight : "100%"}
                    width={imageWidth ? imageWidth : "100%"}
                />
            )}
            <h3 className="h4" css={titleStyles}>
                {title}
            </h3>
            <p css={paragraphStyles}>{paragraph}</p>
        </div>
    );
};
